import axios from "axios";
//import {browserHistory} from 'react-router';

// const
const REDIRECT_TO_ALGORITHM_VIEW = "algorithmView/REDIRECT_TO_ALGORITHM_VIEW";
const ALGORITHM_VIEW_UPDATE_DATA = "algorithmView/ALGORITHM_VIEW_UPDATE_DATA";
const ALGORITHM_VIEW_TOGGLE_MODAL = "algorithmView/ALGORITHM_VIEW_TOGGLE_MODAL";
const ALGORITHM_VIEW_TOGGLE_LOADING = "algorithmView/ALGORITHM_VIEW_TOGGLE_LOADING";

// reducer
export const algorithmView = (state = {
  loading: false,

  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,
  algorithm:[],

  algorithmId: "",
  description: "",
  name: "",
  algorithmCategory: "",
  algorithmType: "",
  algorithmParameters: [],
  algorithmFileId: "",
}, action) => {
  switch (action.type) {
    case REDIRECT_TO_ALGORITHM_VIEW:
      return {
        ...state,
        algorithmId: action.data
      };
    case ALGORITHM_VIEW_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case ALGORITHM_VIEW_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case ALGORITHM_VIEW_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * 前页跳转此页，需要传递参数：algorithm.id
 */
export function redirectToAlgorithmViewPage(algorithmId) {
  return {
    type: REDIRECT_TO_ALGORITHM_VIEW,
    data: algorithmId
  };
}

/**
 * update data based
 */
export const updateAlgorithmViewData = (data) => {
  return {
    type: ALGORITHM_VIEW_UPDATE_DATA,
    data: data
  }
};

/**
 * check and init algorithm
 */
export const initAlgorithm = (data) => (dispatch) => {

  let algorithmId = data.algorithmId;
  if (algorithmId !== null && algorithmId !== undefined && algorithmId !== "") {
    dispatch(toggleLoading(true));
    axios.get(`/api-algorithm/algorithms/search/id?id=${algorithmId}`, {contentType: "application/json"}).then(
      response => {
        if (response.data._embedded.algorithms.length > 0) {
          let algorithm = response.data._embedded.algorithms[0];
          dispatch(updateAlgorithmViewData({
            name: "description",
            value: algorithm.description
          }));
          dispatch(updateAlgorithmViewData({
            name: "name",
            value: algorithm.name
          }));
          dispatch(updateAlgorithmViewData({
            name: "algorithmCategory",
            value: algorithm.algorithmCategory.name
          }));
          dispatch(updateAlgorithmViewData({
            name: "algorithmType",
            value: algorithm.algorithmType.name
          }));
          dispatch(updateAlgorithmViewData({
            name: "algorithmParameters",
            value: algorithm.parameters
          }));
          if (algorithm.algorithmFileId !== null && algorithm.algorithmFileId !== "") {
            dispatch(updateAlgorithmViewData({
              name: "algorithmFileId",
              value: algorithm.algorithmFileId
            }));
          } else {
            dispatch(updateAlgorithmViewData({
              name: "algorithmFileId",
              value: ""
            }));
          }
          dispatch(toggleLoading(false));
        } else {
          dispatch(toggleLoading(false));
          this.props.history.push("/console/algorithm-list");
        }
      }
    );
  } else {
    dispatch(toggleLoading(false));
    this.props.history.push("/console/algorithm-list");
  }
};

/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: ALGORITHM_VIEW_TOGGLE_MODAL,
    data: show
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: ALGORITHM_VIEW_TOGGLE_LOADING,
    data: show
  }
};
